<template>
    <div class="container mb-5">
        <div class="row justify-content-center">
            <div class="col col-lg-9">
                <ul class="list-unstyled text-dark d-flex flex-column gap-4 mb-0">
                    <li
                        v-for="(service, index) in services"
                        :key="index"
                        class="border rounded p-4"
                    >
                        <content-box-item 
                            :document="service.document" 
                            :column-data="service.columnData"
                        />
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import ContentBoxItem from '../ContentCustomServiceBoxItem.vue';
export default {
    components: {
        ContentBoxItem
    },
    props: {
        slice: {
            type: Object,
            required: true
        }
    },
    computed: {
        services() {
            return this.slice.items
                .filter(item => this.$validateContentRelationship(item.custom_service))
                .map(item => {
                    const document = this.$store.state.customServices[item.custom_service.id];
                    const columnData = [1, 2, 3].map(index => {
                        return {
                            header: document.data[`box_data_label_${index}`],
                            value: document.data[`box_data_value_${index}`]
                        };
                    }).filter(item => this.$validateText(item.header) && this.$validateText(item.value));

                    return { 
                        document, 
                        columnData
                    };
                });
        }   
    },
};
</script>